// Tono del badge per ogni stato (valori degli enum del backend: costanti di
// InsurancePolicy, InsuranceAncillary, InsurancePayment, Task,
// CommunicationProcedure e degli invii; etichette in
// resources/lang/it.json). I toni sono quelli
// di StatusBadge: ok, open, wait, ko, off.
const TONES = {
  // Polizza
  policy: {
    0: "wait", // Non perfezionata
    1: "ok", // Perfezionata
    2: "wait", // Sospesa
    3: "off", // Sostituita
    4: "ko", // Annullata
    5: "off", // Scaduta
    6: "off", // Svincolata
    7: "ko", // Abbandonata
    8: "ko", // Disdetta
    9: "ok", // Nuova viva
    10: "ko", // Stornata
    11: "off", // Trasferita
  },
  // Titolo
  ancillary: {
    0: "open", // Da incassare
    1: "ok", // Incassato
    2: "ko", // Stornati
    3: "off", // Annullati manualmente
    4: "off", // Annullati manualmente + annullo polizza
    5: "off", // Annullati su piattaforma compagnia
    6: "off", // Annullati per sostituzione
    7: "wait", // Da validare
  },
  // Sospeso o acconto: stato calcolato in tabella (recoveryStatus in
  // BookEntriesDeferred, BookEntriesDeposited, DeferredCashEntry e
  // DepositedEntryDetails), non un enum del backend.
  recovery: {
    0: "ko", // Aperto
    1: "wait", // Parzialmente recuperato
    2: "ok", // Chiuso
  },
  // Lisapay: stato calcolato in tabella (lisapayStatus qui sotto), non un
  // enum del backend.
  lisapay: {
    0: "ko", // Non registrato
    1: "wait", // Registrato in Compagnia
    2: "ok", // Incassato
    3: "open", // Pagato, da registrare in Compagnia
    4: "ko", // Errore nella registrazione automatica del movimento
  },
  // Attività (Task::STATUS_TASK)
  task: {
    0: "off", // Da iniziare
    1: "open", // In lavorazione
    2: "wait", // In attesa
    3: "ok", // Completato
  },
  // Procedura di comunicazione
  procedure: {
    0: "open", // Inizio
    1: "open", // Esclusioni
    2: "open", // Raggruppamenti
    3: "open", // Modifica
    4: "open", // Template
    5: "wait", // Invio (in corso)
    6: "wait", // Schedulato
    7: "off", // Annullato
    8: "ko", // Errore
    9: "ok", // Completato
    10: "wait", // Completato con errori: concluso, qualche messaggio da ritrasmettere
  },
  // Messaggio di LisaComunica (log): stati stringa, non numerici
  log: {
    SCHEDULED: "wait", // Programmato, in coda
    OK: "ok", // Preso in carico dal provider
    DELIVERED: "ok", // Consegnato
    OPENED: "ok", // Aperto
    TEMP_FAILED: "wait", // Temporaneamente fallito
    FAILED: "ko", // Fallito
  },
  // Invio di una quietanza o di un titolo (scheda Invii)
  sending: {
    0: "ok", // Inviato
    1: "ko", // Fallito
  },
  // Quietanza
  payment: {
    0: "open", // Valido
    1: "wait", // Da validare
    2: "ko", // Mancante
    3: "ok", // Incassato
    4: "off", // Annullato/Stornato
  },
};

/**
 * @param {"policy"|"ancillary"|"payment"|"recovery"|"procedure"|"log"|"sending"|"lisapay"|"task"} kind
 * @param {number|string} value valore dell'enum (stringa per "log")
 * @returns {string} tono del badge; "off" per uno stato sconosciuto
 */
export const statusTone = (kind, value) =>
  TONES[kind]?.[value] ?? TONES[kind]?.[Number(value)] ?? "off";

/**
 * Stato Lisapay di una riga per StatusBadge kind="lisapay". Le righe sono
 * titoli (Titoli: lisapay_paid, charge_error, status_ancillary) o pagamenti
 * Lisapay (Recupero Sospesi: paid, error). Finché la riga non è registrata in
 * Compagnia contano prima l'errore della registrazione automatica del
 * movimento, poi il pagamento; dopo, l'errore di un tentativo precedente non
 * conta più (il backend non lo cancella quando un nuovo tentativo riesce).
 * @param {object} item riga della tabella
 * @param {boolean} [paid] pagata da poco, non ancora aggiornata dal server
 * @returns {{value: number, text: string}}
 */
export const lisapayStatus = (item, paid = false) => {
  if (item?.registered === 0) {
    if ((item.charge_error ?? item.error) != null) {
      return { value: 4, text: "Errore di registrazione" };
    }
    return paid || item.lisapay_paid === 1 || item.paid === 1
      ? { value: 3, text: "Pagato, da registrare" }
      : { value: 0, text: "Non registrato" };
  }
  if (item?.status_ancillary?.value === 0) {
    return { value: 1, text: "Registrato in Compagnia" };
  }
  return { value: 2, text: "Incassato" };
};
